import { render, staticRenderFns } from "./paramsAdd.vue?vue&type=template&id=0c0bedd6&"
import script from "./paramsAdd.vue?vue&type=script&lang=js&"
export * from "./paramsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports